import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../../../../colorVars';
import { MultiSwitch } from '../../../../../../../../../../atomic/buttons/multiSwitch/MultiSwitch';
import CheckBox from '../../../../../../../../../../atomic/formElements/checkBox/CheckBox';
import { BoxInput } from '../../../../../../../../../../atomic/inputs/boxInput/BoxInput';
import {
  Body3,
  fontSizes,
} from '../../../../../../../../../../atomic/text/Text';
import { useAlertFormStore } from '../../../../../alertFormClass';
import style from './CandleTriggerSetupModule.module.css';

export const CandleTriggerSetupModule = observer(() => {
  const form = useAlertFormStore();

  return (
    <div className={`${style.container} noDragTag`}>
      <header className={style.header}>
        <Body3 fontWeight={700} color={colors.lightGrey}>
          Candle Trigger
        </Body3>
      </header>
      <div className={style.body}>
        <div className={style.inputAndLabel}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Break
          </Body3>
          <MultiSwitch
            labels={['Day', 'Week', 'Month']}
            values={['DAYS', 'WEEKS', 'MONTHS']}
            setValue={(value) =>
              form.setupDetails['CANDLE_TRIGGER'].setTimeUnit(value)
            }
            controlledValue={form.setupDetails['CANDLE_TRIGGER'].timeUnit}
          />
        </div>
        <div className={style.inputAndLabel}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Break By
          </Body3>
          <BoxInput
            value={form.setupDetails['CANDLE_TRIGGER'].breakBy}
            setValue={(value) =>
              form.setupDetails['CANDLE_TRIGGER'].setBreakBy(value)
            }
            backgroundColor={colors.grey}
            fontSize={fontSizes.body3}
            width="50px"
            height="20px"
            direction="left"
            symbol="$"
          />
        </div>
        <div className={style.inputAndLabel}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Filter Gaps
          </Body3>
          <CheckBox
            checked={form.setupDetails['CANDLE_TRIGGER'].checkValidation}
            onChange={(checked) =>
              form.setupDetails['CANDLE_TRIGGER'].setCheckValidation(checked)
            }
          />
        </div>
        {form.setupDetails['CANDLE_TRIGGER'].checkValidation ? (
          <>
            <div className={style.inputAndLabel}>
              <Body3 fontWeight={700} color={colors.lightGrey}>
                Bounce on Gap Fill
              </Body3>
              <CheckBox
                checked={form.setupDetails['CANDLE_TRIGGER'].bounceOnGapFill}
                onChange={(checked) =>
                  form.setupDetails['CANDLE_TRIGGER'].setBounceOnGapFill(
                    checked
                  )
                }
                disabled={!form.setupDetails['CANDLE_TRIGGER'].checkValidation}
              />
            </div>
            <div className={style.inputAndLabel}>
              <Body3 fontWeight={700} color={colors.lightGrey}>
                Gap Type
              </Body3>
              <MultiSwitch
                title="High/Low Open/Close"
                labels={['H/L', 'O/C']}
                values={['highLow', 'openClose']}
                setValue={(value) =>
                  form.setupDetails['CANDLE_TRIGGER'].setGapType(value)
                }
                controlledValue={form.setupDetails['CANDLE_TRIGGER'].gapType}
              />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
});
